module.exports = __webpack_public_path__ + "img/send-to-trash.svg";